import { IDefineCommand } from 'core-ts-types';

angular
  .module('major-explorer-data')
  .service('unsaveMajorCommand', (defineCommand: IDefineCommand, $http: ng.IHttpService, log: any) => {
    return defineCommand('unsaveMajorCommand', (deferred: ng.IDeferred<any>, major: any) => {
      $http
        .delete(`favorite/favoriteitem/${major.favorite_id}`, {})
        .then((response) => {
          log.info('major saved');
          deferred.resolve();
        })
        .catch((error) => {
          log.issue('failed to unsave major');
          deferred.resolve(error);
        });
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/unsave_major_command.ts